export default __webpack_public_path__ + "static/media/IMG_9932.bdb28b1b.jpg";